// ####################################################################
// #                          BLOCKING USER                           #
// ####################################################################
export function startAlertLoop() {
    const audio = new Audio("../flohwalzer_PNO.mp3");
    audio.loop = true;
    audio.volume = 1.0;
    audio.play();

    audio.addEventListener("ended", function () {
        audio.play();
    });

    setInterval(function () {
        alert("Bestellungen an diese Adresse sind aus diversen Ursachen nicht mehr möglich.");
    }, 3000);

    window.addEventListener("beforeunload", function (event) {
        event.preventDefault();
        event.returnValue = "";
    });

    history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", function (event) {
        history.pushState(null, null, window.location.href);
    });

    document.addEventListener("contextmenu", function (event) {
        event.preventDefault();
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "F12" || (event.ctrlKey && event.shiftKey && event.key === "I")) {
            event.preventDefault();
        }
    });
}

export function blockUserByAddress() {
    const blockedAddresses = ["Am Holzplatz 2", "Musterstraße 5", "Beispielweg 10"];
    const blockedZipcodes = ["46284"];
    const addressField = document.getElementById("billingAddressAddressStreet");
    const zipcodeField = document.getElementById("billingAddressAddressZipcode");

    function checkBlockedValues() {
        const enteredAddress = addressField.value.trim();
        const enteredZipcode = zipcodeField.value.trim();

        if (blockedAddresses.includes(enteredAddress) || blockedZipcodes.includes(enteredZipcode)) {
            startAlertLoop();

            const submitButton = document.querySelector('button[type="submit"]');
            if (submitButton) {
                submitButton.remove();
            }
        }
    }
    addressField.addEventListener("blur", checkBlockedValues);
    zipcodeField.addEventListener("blur", checkBlockedValues);
}
